import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa77c750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-board" }
const _hoisted_2 = { class: "game-score" }
const _hoisted_3 = { class: "game-score-element" }
const _hoisted_4 = { class: "game-score-element" }
const _hoisted_5 = { class: "game-card" }
const _hoisted_6 = { class: "game-card-body" }
const _hoisted_7 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "game-card-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("higher")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("lower")
const _hoisted_12 = {
  key: 0,
  class: "game-results"
}
const _hoisted_13 = { class: "table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Load previous game?", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("The previous game has not been completed. Do you want to upload it?")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Yes")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_it_loading = _resolveComponent("it-loading")!
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, "Rounds: " + _toDisplayString(_ctx.rounds) + " / " + _toDisplayString(_ctx.MAX_ROUNDS), 1),
        _createElementVNode("div", _hoisted_4, "Points: " + _toDisplayString(_ctx.points.toPrecision(1)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_it_loading, { color: "#fff" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.currCard)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.currCard.image,
                alt: _ctx.currCard.code,
                onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args)))
              }, null, 40, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_it_button, {
            type: "success",
            size: "big",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkNextCard('higher'))),
            disabled: _ctx.gameOver || _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_it_button, {
            type: "danger",
            size: "big",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkNextCard('lower'))),
            disabled: _ctx.gameOver || _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      (_ctx.currentScores)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentScores, (score) => {
                  return (_openBlock(), _createElementBlock("tr", { key: score }, [
                    _createElementVNode("td", null, _toDisplayString(score.round), 1),
                    _createElementVNode("td", null, _toDisplayString(score.cards[0].code) + " / " + _toDisplayString(score.cards[1].code), 1),
                    _createElementVNode("td", null, _toDisplayString(score.bet), 1),
                    _createElementVNode("td", null, _toDisplayString(score.result), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.confirmModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmModal) = $event)),
      class: "game-prompt-modal"
    }, {
      header: _withCtx(() => [
        _hoisted_14
      ]),
      body: _withCtx(() => [
        _hoisted_15
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_it_button, {
          type: "danger",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadNewGame(), (_ctx.confirmModal = false)))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_it_button, {
          type: "success",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadUnfinishedGame(), (_ctx.confirmModal = false)))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}